// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/common.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/v1/common.proto.
 */
export const file_vitesse_v1_common = /*@__PURE__*/ fileDesc("Chd2aXRlc3NlL3YxL2NvbW1vbi5wcm90bxIKdml0ZXNzZS52MSI7CgZSZXN1bHQSDwoHc3VtbWFyeRgBIAEoCRIgCgVlcnJvchgCIAEoCzIRLnZpdGVzc2UudjEuRXJyb3IikQEKBUVycm9yEh4KBGNvZGUYASABKA4yEC52aXRlc3NlLnYxLkNvZGUSEwoLZXhwbGFuYXRpb24YAiABKAkSDgoGcmVtZWR5GAMgASgJEhEKCXJldHJ5YWJsZRgEIAEoCBIfCgRhbHNvGAUgAygLMhEudml0ZXNzZS52MS5FcnJvchIPCgdtaXNzaW5nGAYgASgJKowCCgRDb2RlEhQKEENPREVfVU5TUEVDSUZJRUQQABIZChVDT0RFX0lOVkFMSURfQVJHVU1FTlQQARIYChRDT0RFX1VOQVVUSEVOVElDQVRFRBACEhoKFkNPREVfUEVSTUlTU0lPTl9ERU5JRUQQAxISCg5DT0RFX05PVF9GT1VORBAEEhQKEENPREVfVU5BVkFJTEFCTEUQBRIVChFDT0RFX1JBVEVfTElNSVRFRBAGEhoKFkNPREVfQ09OVFJPTExFUl9JTl9SVU4QBxIRCg1DT0RFX0lOVEVSTkFMEAgSFAoQQ09ERV9FTlRJVExFTUVOVBAJEhcKE0NPREVfQUxSRUFEWV9FWElTVFMQCkKwAQoOY29tLnZpdGVzc2UudjFCC0NvbW1vblByb3RvUAFaSGdpdGh1Yi5jb20vTW92ZW5kaS1haS92aXRlc3NlLXBsYXRmb3JtL3Byb3RvL2dlbi9nby92aXRlc3NlL3YxO3ZpdGVzc2V2MaICA1ZYWKoCClZpdGVzc2UuVjHKAgpWaXRlc3NlXFYx4gIWVml0ZXNzZVxWMVxHUEJNZXRhZGF0YeoCC1ZpdGVzc2U6OlYxYgZwcm90bzM");
/**
 * Describes the message vitesse.v1.Result.
 * Use `create(ResultSchema)` to create a new message.
 */
export const ResultSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_common, 0);
/**
 * Describes the message vitesse.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_common, 1);
/**
 * Semantic error vocabulary. Extend per domain (CONTROLLER_IN_RUN is a domain example). UNSPECIFIED
 * is never returned deliberately.
 *
 * @generated from enum vitesse.v1.Code
 */
export var Code;
(function (Code) {
    /**
     * @generated from enum value: CODE_UNSPECIFIED = 0;
     */
    Code[Code["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CODE_INVALID_ARGUMENT = 1;
     */
    Code[Code["INVALID_ARGUMENT"] = 1] = "INVALID_ARGUMENT";
    /**
     * @generated from enum value: CODE_UNAUTHENTICATED = 2;
     */
    Code[Code["UNAUTHENTICATED"] = 2] = "UNAUTHENTICATED";
    /**
     * @generated from enum value: CODE_PERMISSION_DENIED = 3;
     */
    Code[Code["PERMISSION_DENIED"] = 3] = "PERMISSION_DENIED";
    /**
     * @generated from enum value: CODE_NOT_FOUND = 4;
     */
    Code[Code["NOT_FOUND"] = 4] = "NOT_FOUND";
    /**
     * a dependency is down / unreachable
     *
     * @generated from enum value: CODE_UNAVAILABLE = 5;
     */
    Code[Code["UNAVAILABLE"] = 5] = "UNAVAILABLE";
    /**
     * @generated from enum value: CODE_RATE_LIMITED = 6;
     */
    Code[Code["RATE_LIMITED"] = 6] = "RATE_LIMITED";
    /**
     * domain example — writes refused while running
     *
     * @generated from enum value: CODE_CONTROLLER_IN_RUN = 7;
     */
    Code[Code["CONTROLLER_IN_RUN"] = 7] = "CONTROLLER_IN_RUN";
    /**
     * @generated from enum value: CODE_INTERNAL = 8;
     */
    Code[Code["INTERNAL"] = 8] = "INTERNAL";
    /**
     * The ORG's plan doesn't include this (the money layer refused — distinct from
     * CODE_PERMISSION_DENIED, the trust layer). UIs route this to the upsell /
     * billing page, never to "ask your admin". See plans-entitlements.md §12.2.
     *
     * @generated from enum value: CODE_ENTITLEMENT = 9;
     */
    Code[Code["ENTITLEMENT"] = 9] = "ENTITLEMENT";
    /**
     * The thing you are creating is already there. Distinct from
     * CODE_INVALID_ARGUMENT because the caller's request was well-formed and the
     * right next move is different: a UI or an authoring AI should offer to EDIT
     * what exists rather than ask the user to fix their input. Arrived with the
     * create/edit split, where refusing an id that already exists is what stops a
     * create being a way to overwrite something the caller may not edit.
     *
     * @generated from enum value: CODE_ALREADY_EXISTS = 10;
     */
    Code[Code["ALREADY_EXISTS"] = 10] = "ALREADY_EXISTS";
})(Code || (Code = {}));
/**
 * Describes the enum vitesse.v1.Code.
 */
export const CodeSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_common, 0);
//# sourceMappingURL=common_pb.js.map